var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass:
            "is-flex is-align-items-center is-justify-content-space-between",
        },
        [
          _c("label", { staticClass: "label" }, [_vm._v("Addresses")]),
          _c(
            "button",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.addresses.length < 3,
                  expression: "addresses.length < 3",
                },
              ],
              staticClass: "button is-small is-primary is-light",
              class: `is-light-btn-${_vm.$theme.name}`,
              attrs: {
                disabled:
                  !_vm.countryCode ||
                  (!_vm.$userInfo.isSupportUser &&
                    !_vm.$userInfo.isSystemAdministrator),
              },
              on: { click: _vm.addTmpAddress },
            },
            [_vm._m(0)]
          ),
        ]
      ),
      _vm._l(_vm.addresses, function (address, index) {
        return _c("div", { key: index, staticClass: "pb-4" }, [
          _c("div", { staticClass: "field has-addons" }, [
            _c("p", { staticClass: "control" }, [
              _c("span", { staticClass: "select" }, [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: address.type,
                        expression: "address.type",
                      },
                      {
                        name: "tippy",
                        rawName: "v-tippy",
                        value: {
                          content: "Duplicate Type",
                          theme: "danger",
                          enabled: !_vm.$v.uniqueAddressType,
                        },
                        expression:
                          "{ content: 'Duplicate Type', theme: 'danger', enabled: !$v.uniqueAddressType }",
                      },
                    ],
                    class: { "is-invalid": !_vm.$v.uniqueAddressType },
                    attrs: {
                      disabled:
                        !_vm.$userInfo.isSupportUser &&
                        !_vm.$userInfo.isSystemAdministrator,
                    },
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.$set(
                          address,
                          "type",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      },
                    },
                  },
                  _vm._l(_vm.addressTypes, function (type, typeIndex) {
                    return _c(
                      "option",
                      { key: typeIndex, domProps: { value: typeIndex } },
                      [_vm._v(" " + _vm._s(type) + " ")]
                    )
                  }),
                  0
                ),
              ]),
            ]),
            _c(
              "p",
              { staticClass: "control is-expanded" },
              [
                _vm.googleApi.mapStatus
                  ? _c("google-autocomplete", {
                      attrs: {
                        disabled:
                          !_vm.$userInfo.isSupportUser &&
                          !_vm.$userInfo.isSystemAdministrator,
                        bounds: _vm.googleApi.bounds,
                        id: "address" + index,
                        address: address,
                        v: _vm.$v.addresses.$each[index],
                        "show-address3": true,
                        "country-code": _vm.googleMapAutoCompleteCountryCode,
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
            _c("p", { staticClass: "control" }, [
              _c(
                "button",
                {
                  staticClass: "button has-text-gold",
                  attrs: {
                    disabled:
                      (_vm.addresses.length == 1 && address.isDefault) ||
                      (!_vm.$userInfo.isSupportUser &&
                        !_vm.$userInfo.isSystemAdministrator),
                  },
                  on: {
                    click: function ($event) {
                      return _vm.setDefault(address)
                    },
                  },
                },
                [
                  _c("span", { staticClass: "icon" }, [
                    _c(
                      "span",
                      {
                        staticClass: "mso mso-24px",
                        class: [address.isDefault ? "mso-fill" : ""],
                      },
                      [_vm._v(" star ")]
                    ),
                  ]),
                ]
              ),
            ]),
            _c("p", { staticClass: "control" }, [
              _c(
                "button",
                {
                  staticClass: "button has-text-danger",
                  attrs: {
                    disabled:
                      _vm.addresses.length == 1 ||
                      address.isDefault ||
                      (!_vm.$userInfo.isSupportUser &&
                        !_vm.$userInfo.isSystemAdministrator),
                  },
                  on: {
                    click: function ($event) {
                      return _vm.removeAddress(address)
                    },
                  },
                },
                [_vm._m(1, true)]
              ),
            ]),
          ]),
        ])
      }),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("span", { staticClass: "mso mso-24px" }, [_vm._v(" add ")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("span", { staticClass: "mso mso-24px" }, [_vm._v(" remove ")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }